/**
 * Takes an enum value and a number. Returns true if the number
 * contains the bitwise enum value or false otherwise.
 */
export function hasBitwise(enumValue, numValue) {
  return (numValue & enumValue) === enumValue;
}
